import { FC } from 'react';
import { SidebarMenu } from '@/components/SidebarMenu';
import { getUserEditRoutes } from '@/containers/pages/user/utils';
import { isFeature } from '@utils/feature';
import { ROUTES } from '@/containers/routes/constants';
import { useTranslation } from 'react-i18next';
import { useGetNavMenuItems } from './useGetNavMenuItems';

interface IMenuProps {
  setIsOpen: (isOpen: boolean) => void;
}

export const NavMenu: FC<IMenuProps> = ({ setIsOpen }) => {
  const { t } = useTranslation();
  const { editProfileNavItems } = useGetNavMenuItems();
  const linksBlocks = [
    {
      label: t('profil'),
      pages: isFeature()
        ? editProfileNavItems
        : editProfileNavItems.filter((item) => item.value !== ROUTES.profile.pages.settings)
    }
  ];
  return (
    <SidebarMenu routes={getUserEditRoutes()} setIsOpen={setIsOpen} linksBlocks={linksBlocks} />
  );
};
